import { LockerFile } from "./Locker/LockerFile";
import { IContent } from "./Content";
import { Profile } from "./User";
import { Author } from "./Social";

export interface Notifications {
    arePreviousUnreads: boolean
    firstAlert: Alert
    followingContentAuthor?: string
    groupCount: number
    links: Link[]
    mostRecentDateTime: string
    readStatus: boolean
    secondAlert?: Alert
    text: string
    type: NotificationType
}

export interface NotificationsResponse {
    nextUrl: string
    notifications: Notifications[]
    previousUrl?: string
}

interface Alert {
    appGuid: string
    comment: Comment
    commentId: number
    content: IContent
    contentId: number
    contentTitle: string
    createDate: string
    createdBy: Profile
    createdById: number
    focusComment: Comment
    focusCommentId?: number
    id: number
    lockerFile: LockerFile
    notifyUserId: number
    parentContent: IContent
    parentContentId?: number
    readStatus: false
    removed: false
    type: NotificationType
    eventId: number
    eventResource: EventResource
}

interface EventResource {
    id: number,
    title: string
}

interface Link {
    href: string
    httpBody: any
    method: string
    rel: string
}

interface Comment {
    atMentionUsers?: number
    author: Author
    body: string
    contentId: number
    createDate: string
    deleted: boolean
    id: number
    links: Link[]
    modifiedDate?: string
    parentId?: number
    row: number
    status: number
    totalLikes: number
    totalReplies: number
    url: string
    userLiked: number[]
}


export enum NotificationType {
    userGeneratedContent = 'userGeneratedContent',
    comment = "comment",
    commentLike = "commentLike",
    like = "like",
    acknowledgementCompliance = "acknowledgementCompliance",
    acknowledgementEvent = "acknowledgementEvent",
    acknowledgementCompetition = "acknowledgementCompetition",
    commentAtMention = "commentAtMention",
    lockerNewFileAdded = "lockerNewFileAdded",
    lockerPasscodeSetupReady = "lockerPasscodeSetupReady",
    plannerEventCreated = "plannerEventCreated",
    plannerEventCancelled = "plannerEventCancelled",
    plannerEventReplyApproved = "plannerEventReplyApproved",
    plannerEventReplyDeclined = "plannerEventReplyDeclined",
    pushFromPage = "pushFromPage",
    recognition = "recognition",
    accountRecoveryRequest = "accountRecoveryRequest",
    signInCodeRequest = "signInCodeRequest"
}

